import { render, staticRenderFns } from "./catalogModal.vue?vue&type=template&id=5adc7074&"
import script from "./catalogModal.vue?vue&type=script&lang=ts&"
export * from "./catalogModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports